<template>
    <div class="bgray-100">
        <b-row class="bgray-200 mb-5 py-4 align-items-center" no-gutters>
            <b-col cols="12" lg="3">
                <b-btn
                    variant="icon"
                    :to="{ name: 'TemplateList' }"
                    class="mb-2 ml-3"
                    :disabled="!is_loaded_initial_data"
                    small
                    >
                    &lang; <span class="pl-2">질문지 목록으로 이동</span>
                </b-btn>
            </b-col>
            <b-col cols="12" lg="6">
                <div class="d-flex justify-content-center align-items-center">
                    <h2 class="fw-400 text-center py-5 mb-0"> LIST OF Parser Values</h2>
                </div>
            </b-col>
        </b-row>

        <b-container tag="section" class="py-4">
            <b-row class="mb-5 mb-lg-5 justify-content-lg-center">
                <b-col cols="12" lg="6">
                    <b-form @reset.prevent="resetValuesForm">
                        <b-form-row class="mb-3">
                            <b-col cols="12" lg="6">
                                <h4 class="fw-600 mb-0"> Parser 결과값 조회 </h4>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <div class="text-right">
                                    <b-btn type="reset" variant="danger" size="sm" :disabled="ValuesGlobalDisabled">
                                        전체 초기화
                                        <b-spinner v-show="!is_loaded_initial_data" style="width:1rem;height:1rem;" />
                                    </b-btn>
                                </div>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <b-col cols="12">
                                <b-card class="border-0 shadow-sm py-2">
                                    <b-form-row class="mb-3">
                                        <b-col cols="12" lg="3">
                                            <label
                                                id="input-values-project-label"
                                                for="input-values-project"
                                                class="gray-600 fw-500 mb-2 mb-lg-0"
                                                >
                                                프로젝트
                                            </label>
                                        </b-col>
                                        <b-col cols="7" lg>
                                            <b-form-select id="input-values-project"
                                                v-model="selected_project"
                                                :options="projects"
                                                text-field="project_code"
                                                value-field="project_code"
                                                :disabled="!projects || ValuesGlobalDisabled"
                                                />
                                        </b-col>
                                        <b-col cols="5" lg="auto">
                                            <b-btn variant="danger"
                                                :disabled="!projects || ValuesGlobalDisabled"
                                                @click="selected_project = null"
                                                >
                                                <BIconArrowClockwise />
                                            </b-btn>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row class="mb-3">
                                        <b-col cols="12" lg="3">
                                            <label
                                                id="input-values-campaign-label"
                                                for="input-values-campaign"
                                                class="gray-600 fw-500 mb-2 mb-lg-0"
                                                >
                                                캠페인
                                            </label>
                                        </b-col>
                                        <b-col cols="7" lg>
                                            <b-form-select id="input-values-campaign"
                                                v-model="selected_campaign"
                                                :options="campaigns"
                                                text-field="campaign_name"
                                                value-field="campaign_id"
                                                :disabled="!campaigns || ValuesGlobalDisabled"
                                                />
                                        </b-col>
                                        <b-col cols="5" lg="auto">
                                            <b-btn variant="danger"
                                                :disabled="!campaigns || ValuesGlobalDisabled"
                                                @click="selected_campaign = null"
                                                >
                                                <BIconArrowClockwise />
                                            </b-btn>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row class="mb-3">
                                        <b-col cols="12" lg="3">
                                            <label
                                                id="input-values-question-label"
                                                for="input-values-question"
                                                class="gray-600 fw-500 mb-2 mb-lg-0"
                                                >
                                                질문 문항
                                            </label>
                                        </b-col>
                                        <b-col cols="12" lg>
                                            <b-form-select id="input-values-question"
                                                v-model="selected_question"
                                                :options="questions"
                                                text-field="question_name"
                                                value-field="question_code"
                                                :disabled="!questions || ValuesGlobalDisabled"
                                                />
                                        </b-col>
                                        <b-col cols="5" lg="auto">
                                            <b-btn variant="danger"
                                                :disabled="!questions || ValuesGlobalDisabled"
                                                @click="selected_question = null"
                                                >
                                                <BIconArrowClockwise />
                                            </b-btn>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row>
                                        <b-col cols="12" lg="3">
                                            <label
                                                id="input-values-criteria-label"
                                                for="input-values-criteria"
                                                class="gray-600 fw-500 mb-2 mb-lg-0"
                                                >
                                                집계 항목
                                            </label>
                                        </b-col>
                                        <b-col cols="12" lg>
                                            <b-form-select id="input-values-criteria"
                                                v-model="selected_criteria"
                                                :options="criterias"
                                                text-field="criteria_name"
                                                value-field="criteria_id"
                                                :disabled="!criterias || ValuesGlobalDisabled"
                                                />
                                        </b-col>
                                        <b-col cols="5" lg="auto">
                                            <b-btn variant="danger"
                                                :disabled="!criterias || ValuesGlobalDisabled"
                                                @click="selected_criteria = null"
                                                >
                                                <BIconArrowClockwise />
                                            </b-btn>
                                        </b-col>
                                    </b-form-row>
                                </b-card>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-col>
                <b-col cols="12" lg="5">
                    <div class="d-flex flex-column h-100">
                        <!-- <h4 class="mb-2">검색 결과</h4> -->
                        <h4 class="fw-500 mb-4"> 검색 결과 </h4>
                        <b-card class="border-0 shadow-sm h-100" no-body>
                            <div class="d-flex flex-column justify-content-between h-100">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex justify-content-between align-items-center flex-grow-1 p-3">
                                        <h6 class="gray-600 fw-400 mb-0">프로젝트 수</h6>
                                        <h2 class="mb-0">{{ valuesStatics.project }} 개</h2>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center flex-grow-1 p-3">
                                        <h6 class="gray-600 fw-400 mb-0">캠페인 수</h6>
                                        <h2 class="mb-0">{{ valuesStatics.campaign }} 개</h2>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex justify-content-between align-items-center flex-grow-1 p-3">
                                        <h6 class="gray-600 fw-400 mb-0">질문 문항수</h6>
                                        <h2 class="mb-0">{{ valuesStatics.question }} 개</h2>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center flex-grow-1 p-3">
                                        <h6 class="gray-600 fw-400 mb-0">집계 항목수</h6>
                                        <h2 class="mb-0">{{ valuesStatics.criteria }} 개</h2>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between w-100 w-xl-50">
                                    <div class="d-flex justify-content-between align-items-center flex-grow-1 p-3">
                                        <h6 class="gray-600 fw-400 mb-0">조회 기업수</h6>
                                        <h2 class="mb-0">{{ valuesStatics.company }} 개</h2>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <b-row class="justify-content-lg-center">
                <b-col cols="12" lg="11" class="mb-3">
                    <div class="d-flex justify-content-between">
                        <h4 class="fw-600 mb-0"> Values 수정 및 조회 </h4>
                        <div>
                            <b-btn variant="primary"
                                size="sm"
                                class="mr-3"
                                :disabled="ValuesGlobalDisabled || !values || !values.length || (!selected_campaign && !selected_question && !selected_criteria)"
                                @click="downloadSearchData"
                                >
                                조회 데이터 엑셀 다운로드
                            </b-btn>
                            <b-btn variant="primary"
                                size="sm"
                                :disabled="ValuesGlobalDisabled || !raw_values || !raw_values.length"
                                @click="downloadRawData"
                                >
                                전체 데이터 엑셀 다운로드
                            </b-btn>
                        </div>
                    </div>
                    <div :class="[{'d-flex': is_downloading_excel.state}, {'d-none': !is_downloading_excel.state}, 'align-items-center justify-content-end mt-2']">
                        <span class="mr-2">{{ is_downloading_excel.process }}</span>
                        <b-spinner v-show="is_downloading_excel.state" small />
                    </div>
                </b-col>
                <b-col cols="12" lg="11">
                    <b-alert :show="!!load_error" variant="danger" class="d-flex align-items-center justify-content-between">
                        <span>파서 값을 불러오지 못했습니다. ({{ load_error }})</span>
                        <b-btn size="sm" variant="outline-danger" @click="reloadInitialData">다시 시도</b-btn>
                    </b-alert>
                    <b-table id="values-table"
                        :items="values"
                        :fields="valuesField"
                        :per-page="perPage"
                        :current-page="currentPage"
                        responsive
                        show-empty
                        :emptyText="!is_loaded_initial_data ? '불러오는중...' : load_error ? '데이터를 불러오지 못했습니다.' : '선택된 검색조건을 없거나 또는 검색된 데이터가 없습니다.'"
                        sticky-header
                        no-border-collapse
                        class="bg-white border"
                        >
                        <template #empty="scope">
                            <div class="text-center">
                                <h4 class="mb-0">{{ scope.emptyText }}</h4>
                            </div>
                        </template>

                        <template #cell(index)="data">
                            {{ data.value }}
                            ({{ data.item.value_id }})
                        </template>

                        <template #cell(question_name)="data">
                            {{ data.value }}
                            ({{ data.item.question_code }})
                        </template>

                        <template #cell(cta)="data">
                            <b-btn variant="danger"
                                size="sm"
                                :disabled="ValuesGlobalDisabled"
                                @click="deleteValues(data.item)"
                                >
                                <span v-show="`value-delete-${data.item.index}-state` !== is_deleting_value.target">
                                    삭제
                                </span>

                                <b-spinner v-show="`value-delete-${data.item.index}-state` === is_deleting_value.target"
                                    style="width: 1.2rem;height: 1.2rem;"/>
                            </b-btn>
                        </template>
                    </b-table>

                    <div class="d-flex justify-content-center mt-4">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            :disabled="ValuesGlobalDisabled"
                            aria-controls="values-table"
                            >
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import downloadFile from '@shared_mixins/downloadFile';
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'ManagingParserValues',
    mixins: [
        downloadFile
    ],
    data () {
        return {
            load_error: '',
            is_loaded_initial_data: false,
            is_parsing_criteriaDefinition: {
                progress: false,
                success: null
            },
            projects: null,
            campaigns: null,
            questions: null,
            criterias: null,
            companies: null,
            selected_project: null,
            selected_campaign: null,
            selected_question: null,
            selected_criteria: null,
            selected_company: null,
            raw_values: null,
            values: null,
            valuesStatics: {
                project: 0,
                campaign: 0,
                company: 0, // 집계 기업 개수
                question: 0, // 집계 질문 개수
                criteria: 0 // 집계 항목 개수
            },
            valuesField: [
                // {
                //     key: 'index',
                //     label: 'Index (value_id)',
                //     sortable: true
                // },
                {
                    key: 'project_code',
                    label: '프로젝트 코드',
                    thStyle: 'width: 13%;',
                    sortable: true
                },
                {
                    key: 'campaign_name',
                    label: '캠페인 이름',
                    sortable: true,
                    thStyle: 'width: 13%;',
                },
                {
                    key: 'question_name',
                    label: '질문 이름',
                    sortable: true
                },
                {
                    key: 'sub_code',
                    label: 'sub code',
                    sortable: true,
                    thClass: 'text-nowrap'
                },
                {
                    key: 'criteria_name',
                    label: '집계 항목',
                    sortable: true,
                    thClass: 'text-nowrap',
                    thStyle: 'width: 15%;',
                },
                {
                    key: 'year',
                    label: '연도',
                    sortable: true
                },
                {
                    key: 'company_name',
                    label: '회사명',
                    sortable: true,
                    thStyle: 'width: 13%;',
                    tdClass: 'no-word-break'
                },
                {
                    key: 'value',
                    label: '값',
                    thStyle: 'width: 7%;',
                    sortable: true
                },
                {
                    key: 'unit',
                    label: '단위',
                    sortable: true
                },
                {
                    key: 'cta',
                    label: '삭제',
                    sortable: false
                },
            ],
            currentPage: 1,
            totalRows: 0,
            perPage: 25,
            is_downloading_excel: {
                state: false,
                process: null
            },
            is_deleting_value: {
                state: false,
                target: null
            }
        }
    },
    computed: {
        ValuesGlobalDisabled () {
            return !this.is_loaded_initial_data ||
                this.is_downloading_excel.state === true ||
                this.is_deleting_value.state === true ||
                this.is_parsing_criteriaDefinition.progress === true
        }
    },
    watch: {
        selected_project (_selected_project) {
            if (this.raw_values) {
                this.campaigns = this.aggregateCampaigns()
                this.questions = this.aggregateQuestions()
                this.criterias = this.aggregateCriterias()

                if (!_selected_project) {
                    this.projects = this.aggregateProjects()
                }
            }

            this.filterValues()
            this.analyzeValues()
        },
        selected_campaign (_selected_campaign) {
            if (this.raw_values) {
                this.projects = this.aggregateProjects()
                this.questions = this.aggregateQuestions()
                this.criterias = this.aggregateCriterias()

                let _selected_question = null
                if (this.selected_question) {
                    _selected_question = this.questions.find(_question => _question.question_code === this.selected_question)
                }

                if (!_selected_question) {
                    this.selected_question = null
                } else {
                    const _question_in_newList = this.questions.find(({ question_name }) => question_name === _selected_question.question_name)
                    this.selected_question = !_question_in_newList ? null : _question_in_newList.question_code
                }

                if (!_selected_campaign) {
                    this.campaigns = this.aggregateCampaigns()
                }

            }

            this.filterValues()
            this.analyzeValues()
        },
        selected_question (_selected_question) {
            if (this.raw_values) {
                this.projects = this.aggregateProjects()
                this.campaigns = this.aggregateCampaigns()
                this.criterias = this.aggregateCriterias()

                if (this.selected_criteria) {
                    const _selected_criteria = this.selected_criteria

                    const _is_included_criteria = this.criterias.find(({ criteria_id }) => criteria_id === _selected_criteria)
                    if (_is_included_criteria) {
                        this.selected_criteria = _selected_criteria
                    } else {
                        this.selected_criteria = null
                    }
                }
                
                if (!_selected_question) {
                    this.questions = this.aggregateQuestions()
                }
            }

            this.filterValues()
            this.analyzeValues()
        },
        selected_criteria (_selected_criteria) {
            this.projects = this.aggregateProjects()
            this.campaigns = this.aggregateCampaigns()
            this.questions = this.aggregateQuestions()

            if (!_selected_criteria) {
                this.criterias = this.aggregateCriterias()   
            }

            this.filterValues()
            this.analyzeValues()
        }
    },
    async created () {
        await this.reloadInitialData()
    },
    mounted () {},
    methods: {
        async reloadInitialData () {
            this.is_loaded_initial_data = false
            this.load_error = ''
            await this.readParserCategory()
            await this.readParsedValues()
            this.is_loaded_initial_data = true
        },
        async readParserCategory () {
            try { 
                let res_category = await this.$axios.get('/parser/categories')
                this.categories = res_category.data
            } catch (error) {
                if (error) {
                    console.log(` ~ error => `, error);
                    if (error.response) {
                        console.log(` ~ error.response => `, error.response);
                    }   
                }
                this.load_error = getErrorMessage(error, '카테고리 조회 실패')
            }
        },
        async readParsedValues () {
            try {
                const params = { type: 'figure' }
                let res_values = await this.$axios.get('/parser/values', { params })
                
                this.projects = this.aggregateProjects(res_values.data)
                this.campaigns = this.aggregateCampaigns(res_values.data)
                this.questions = this.aggregateQuestions(res_values.data)
                this.criterias = this.aggregateCriterias(res_values.data)

                this.raw_values = res_values.data
                this.values = res_values.data

                this.analyzeValues()
            } catch (error) {
                if (error.response) {
                    console.log(` ~ error.response => `, error.response);
                } else {
                    console.log(` ~ error => `, error);
                }
                this.load_error = getErrorMessage(error, '값 조회 실패')
            }
        },
        aggregateProjects (raws) {
            let _filtered_projects = this.aggregateCommonFilterRawValues('project', raws)
            if (_filtered_projects.length) {
                _filtered_projects = _filtered_projects.map(({ project_code }) => project_code)
                _filtered_projects = new Set(_filtered_projects)
                return [ ..._filtered_projects ].map(project_code => ({ project_code }))
            } else {
                return []
            }
        },
        aggregateCampaigns (raws) {
            let _filtered_campaigns = this.aggregateCommonFilterRawValues('campaign', raws)
            if (!_filtered_campaigns.length) {
                return []
            } else {
                return _filtered_campaigns.reduce((_campaigns, raw) => {
                    const _is_existed_campaign = _campaigns.find(_campaign => _campaign.campaign_id === raw.campaign_id)
                    if (!_is_existed_campaign) {
                        _campaigns.push({ campaign_id: raw.campaign_id, campaign_name: raw.campaign_name })
                    }
                    return _campaigns
                }, [])
            }
        },
        aggregateQuestions (raws) {
            let _filtered_questions = this.aggregateCommonFilterRawValues('question', raws)
            if (!_filtered_questions.length) {
                return []
            } else {
                return _filtered_questions.reduce((_questions, raw) => {
                    const _is_existed_question = _questions.find(_question => _question.question_name === raw.question_name)
                    if (!_is_existed_question) {
                        _questions.push({ question_name: raw.question_name, question_code: raw.question_code })
                    }
                    return _questions
                }, [])
            }
        },
        aggregateCriterias (raws) {
            let _filtered_questions = this.aggregateCommonFilterRawValues('criteria', raws)
            if (!_filtered_questions.length) {
                return []
            } else {
                return _filtered_questions.reduce((_criterias, raw) => {
                    const _is_existed_criteria = _criterias.find(({ criteria_id }) => criteria_id === raw.criteria_id)
                    if (!_is_existed_criteria) {
                        _criterias.push({ criteria_id: raw.criteria_id, criteria_name: raw.criteria_name })
                    }
                    return _criterias
                }, [])
            }
        },
        aggregateCommonFilterRawValues (filterField, _raw_values = this.raw_values) {
            let _filtered_raw_values = _raw_values
            if (filterField !== 'project' && this.selected_project) {
                _filtered_raw_values = _filtered_raw_values.reduce((_values, _value) => {
                    if (this.selected_project === _value.project_code) {
                        _values.push(_value)
                    }
                    return _values
                }, [])
            }

            if (filterField !== 'campaign' && this.selected_campaign) {
                _filtered_raw_values = _filtered_raw_values.reduce((_values, _value) => {
                    if (this.selected_campaign === _value.campaign_id) {
                        _values.push(_value)
                    }
                    return _values
                }, [])
            }

            if (filterField !== 'question' && this.selected_question) {
                _filtered_raw_values = _filtered_raw_values.reduce((_values, _value) => {
                    if (this.selected_question === _value.question_code) {
                        _values.push(_value)
                    }
                    return _values
                }, [])
            }

            if (filterField !== 'criteria' && this.selected_criteria) {
                _filtered_raw_values = _filtered_raw_values.reduce((_values, _value) => {
                    if (this.selected_criteria === _value.criteria_id) {
                        _values.push(_value)
                    }
                    return _values
                }, [])
            }

            return _filtered_raw_values
        },
        filterValues () {
            let _values = [ ...this.raw_values ]

            if (this.selected_project) {
                _values = _values.filter(_value => _value.project_code === this.selected_project)
            }
            
            if (this.selected_campaign) {
                _values = _values.filter(_value => _value.campaign_id === this.selected_campaign)
            }

            if (this.selected_question) {
                if (this.selected_campaign) {
                    _values = _values.filter(_value => _value.question_code === this.selected_question)
                } else {
                    const _question = this.questions.find(({ question_code}) => question_code === this.selected_question)
                    if (_question) {
                        _values = _values.filter(_value => _value.question_name === _question.question_name)
                    }
                }
            }

            if (this.selected_criteria) {
                _values = _values.filter(_value => _value.criteria_id === this.selected_criteria)
            }

            this.values = _values
        },
        analyzeValues () {
            if (!this.values) {
                this.valuesStatics = { project: 0, campaign: 0, company: 0, question: 0, criteria: 0 }
            } else {
                const analytics = this.values.reduce((_analytics, _value) => {
                    _analytics.project.add(_value.project_code)
                    _analytics.campaign.add(_value.campaign_id)
                    _analytics.company.add(_value.company_id)
                    _analytics.question.add(_value.question_name)
                    _analytics.criteria.add(_value.criteria_name)
                    return _analytics
                }, {
                    project: new Set(), campaign: new Set(), company: new Set(), question: new Set(), criteria: new Set()
                })
                
                this.valuesStatics = {
                    project: analytics.project.size, // 집계 프로젝트 개수
                    campaign: analytics.campaign.size, // 집계 캠페인 개수
                    company: analytics.company.size, // 집계 기업 개수
                    question: analytics.question.size, // 집계 질문 개수
                    criteria: analytics.criteria.size // 집계 항목 개수
                }

                this.currentPage = 1
                this.totalRows = this.values.length
            }
        },
        async deleteValues (value) {
            try {
                this.is_deleting_value.state = true
                this.is_deleting_value.target = `value-delete-${value.index}-state`
                const _is_confirmed_delete_value = confirm('해당 Value를 삭제하시겠습니까?')
                if (_is_confirmed_delete_value) {
                    const res_delete_parser = await this.$axios.delete('/parser/values', {
                        params: {
                            value_id: value.value_id
                        }
                    })

                    const _deleted_value_id = Number(res_delete_parser.data.value_id)
                    const _delete_target_raw_values_index = this.raw_values.findIndex(_value => _value.value_id === _deleted_value_id)
                    const _delete_target_values_index = this.values.findIndex(_value => _value.value_id === _deleted_value_id)
                    let _raw_values = [...this.raw_values ],
                        _values = [ ...this.values ]
                    
                    if (!!_raw_values && _raw_values.length && _delete_target_raw_values_index > -1) {
                        _raw_values.splice(_delete_target_raw_values_index, 1)
                        this.raw_values = _raw_values
                    }

                    if (!!_values && _values.length && _delete_target_values_index > -1) {
                        _values.splice(_delete_target_values_index, 1)
                        this.values = _values
                    }

                    this.$forceUpdate()
                }
            } catch (error) {
                if (error.response) {
                    console.log(` ~ error.response => `, error.response);
                } else {
                    console.log(` ~ error => `, error);
                    
                }
                alert('Value 삭제중 오류가 발생했습니다. 데이터를 새로 불러오겠습니다.')
                this.is_loaded_initial_data = false
                await this.readParserCategory()
                await this.readParsedValues()
                this.is_loaded_initial_data = true
            } finally {
                this.is_deleting_value.target = null
                this.is_deleting_value.state = false
            }
        },
        async downloadRawData () {
            this.is_downloading_excel.state = true
            this.is_downloading_excel.process = '전체 기업답변 데이터 엑셀파일을 생성하는 중입니다.'

            try {
                const response = await this.$axios.get(`/parser/values/excel`, {
                    params: { type: 'figure' },
                    responseType: 'blob'
                })

                const excelname = this.generateFullDataSheetname()
                this.downloadFileFromResponse(response, `Assessment_${excelname}`)
            } catch (error) {
                this.notifyDownloadFailure(error)
            } finally {
                this.is_downloading_excel.process = null
                this.is_downloading_excel.state = false
            }
        },
        notifyDownloadFailure (error) {
            console.log(` ~ error => `, error);
            this.$EventBus.$emit('toast-failure', '엑셀 다운로드 실패', getErrorMessage(error, '엑셀 파일을 내려받지 못했습니다. 잠시 후 다시 시도해 주세요.'))
        },
        async downloadSearchData () {
            this.is_downloading_excel.state = true
            this.is_downloading_excel.process = '상세조회 기업답변 데이터 엑셀파일 생성중'

            try {
                const excelname = this.generateFullDataSheetname()
                const _download_query = { type: 'figure' }

                if (this.selected_project) {
                    _download_query.project_code = this.selected_project
                }

                if (this.selected_campaign) {
                    _download_query.campaign_id = this.selected_campaign
                }

                if (this.selected_question) {
                    if (this.selected_campaign) {
                        _download_query.question_code = this.selected_question
                    } else {
                        const _question = this.questions.find(({ question_code }) => question_code === this.selected_question)
                        _download_query.question_name = _question.question_name
                    }
                }

                if (this.selected_criteria) {
                    _download_query.criteria_id = this.selected_criteria
                }

                const response = await this.$axios.get(`/parser/values/excel`, {
                    params: _download_query,
                    responseType: 'blob'
                })

                this.downloadFileFromResponse(response, `${excelname}_답변_집계값`)
            } catch (error) {
                this.notifyDownloadFailure(error)
            } finally {
                this.is_downloading_excel.process = null
                this.is_downloading_excel.state = false
            }
        },
        generateFullDataSheetname () {
            let excelname = null

            if (this.selected_project || this.selected_campaign || this.selected_question || this.selected_criteria) {
                excelname = []

                if (this.selected_project) {
                    excelname.push(this.selected_project)
                }

                if (this.selected_campaign) {
                    const _selected_campaign = this.campaigns.find(({ campaign_id }) => campaign_id === this.selected_campaign)
                    excelname.push(_selected_campaign.campaign_name)
                }

                if (this.selected_question) {
                    const _selected_question = this.questions.find(({ question_code }) => question_code === this.selected_question)
                    excelname.push(_selected_question.question_name)
                }

                if (this.selected_criteria) {
                    excelname.push(this.selected_criteria)
                }

                excelname = excelname.join('_')
                excelname = `${excelname} - 상세조회_기업답변_데이터`
            } else {
                excelname = '전체_기업답변_데이터'
            }

            return excelname
        },
        async parseCriteriaDefinition() {
			let _is_parsing_criteriaDefinition_success = true
			try {
				this.is_parsing_criteriaDefinition.progress = true

				const parsingDefinitionFormData = new FormData()
                parsingDefinitionFormData.append('type', 'figure')
                await this.$axios.post('/parser/values', parsingDefinitionFormData)
				
				_is_parsing_criteriaDefinition_success = true
			} catch (error) {
				if (error.response) {
					if (error.response.status === 401) {
						await this.commonLogout()
					}
				}

				_is_parsing_criteriaDefinition_success = false
			} finally {
				this.is_parsing_criteriaDefinition = {
					progress: false,
					success: _is_parsing_criteriaDefinition_success
				}

				setTimeout(async () => {
					this.is_parsing_criteriaDefinition = {
						progress: false,
						success: null
					}

                    await this.resetValuesForm()
				}, 1500);
			}
		},
        async resetValuesForm () {
            this.is_loaded_initial_data = false

            this.selected_project = null
            this.selected_campaign = null
            this.selected_question = null
            this.selected_criteria = null
            this.selected_company = null

            this.campaigns = null
            this.questions = null
            this.criterias = null
            this.companies = null

            this.raw_values = null,
            this.values = null
            
            this.valuesStatics = {
                campaign: 0,
                company: 0, // 집계 기업 개수
                question: 0, // 집계 질문 개수
                criteria: 0 // 집계 항목 개수
            },
            
            this.currentPage = 1
            this.totalRows = 0

            this.is_downloading_excel = { state: false, process: null }
            this.is_deleting_value = { state: false, target: null }

            await this.readParserCategory()
            await this.readParsedValues()
            this.is_loaded_initial_data = true
        }
    }
}
</script>

<style>

</style>